var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2021 SICK AG
 */
import { Component, CustomElement, Event, html, Prop, nothing, Watch, State } from '@sick-davinci/ce-decorators';
import { style } from './Popout.style';
/**
 * Definition of sides, on which the Popout can be rendered
 */

export
/**
 * The `davinci-popout` generates a popout-bubble on a certain element.
 * It automatically registers click- or hover-handlers on the target-element, that will toggle the popout open/close.
 * It positions itself aside the target-element and aligns the center of the tip to the middle of the bound element-side.
 *
 * @example
 * ```html
 * <button id="ButtonID">open popout</button>
 * <davinci-popout target="#ButtonID">
 *  <h1>My Content</h1>
 *  <p>Some more text ...</p>
 * </davinci-popout>
 * ```
 */
let Popout = (_dec = Component({
  style: [style],
  tag: 'davinci-popout',
  dependencies: []
}), _dec2 = Prop({
  type: Boolean
}), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop({
  type: Boolean
}), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop({
  type: Boolean
}), _dec7 = Reflect.metadata("design:type", Boolean), _dec8 = Prop({
  type: String
}), _dec9 = Reflect.metadata("design:type", Object), _dec10 = Prop({
  type: String
}), _dec11 = Reflect.metadata("design:type", Object), _dec12 = Prop({
  type: String
}), _dec13 = Reflect.metadata("design:type", String), _dec14 = Prop({
  type: String
}), _dec15 = Reflect.metadata("design:type", String), _dec16 = Event('open'), _dec17 = Reflect.metadata("design:type", Object), _dec18 = State(), _dec19 = Reflect.metadata("design:type", Boolean), _dec20 = Watch('target'), _dec21 = Reflect.metadata("design:paramtypes", [String]), _dec22 = Watch('open'), _dec23 = Reflect.metadata("design:paramtypes", []), _dec24 = Watch('trigger'), _dec25 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = class Popout extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "altDirection", _descriptor, this);

    _initializerDefineProperty(this, "noBackdrop", _descriptor2, this);

    _initializerDefineProperty(this, "open", _descriptor3, this);

    _initializerDefineProperty(this, "side", _descriptor4, this);

    _initializerDefineProperty(this, "target", _descriptor5, this);

    _initializerDefineProperty(this, "trigger", _descriptor6, this);

    _initializerDefineProperty(this, "type", _descriptor7, this);

    _initializerDefineProperty(this, "openEvent", _descriptor8, this);

    _initializerDefineProperty(this, "_defaultTrigger", _descriptor9, this);

    this._resizeObservers = [];
    this._mutationObservers = [];

    this._toggleCallback = () => this.open = !this.open;

    this._openCallback = () => this.open = true;

    this._closeCallback = () => this.open = false;

    this._setPositionCallback = () => {
      this._setPosition();
    };
  }

  onTargetChange(oldValue) {
    if (!this.target) {
      var _console;

      (_console = console) === null || _console === void 0 ? void 0 : _console.warn('You did not set the `target` attribute. The Popout will not work properly without a referencing element!', this); // tslint:disable-line:no-console
    }

    this._updateTargetBindings(this.target, oldValue);

    this._updateDomObservers();
  }

  onOpenChange() {
    this.openEvent.emit(this.open);
  }

  onTriggerChange() {
    this.open = false;
    this._defaultTrigger = this.trigger !== 'none' && this.trigger !== 'hover';

    this._updateTargetBindings(this.target);

    this._updateDomObservers();
  }

  componentFirstRender() {
    this._scrollbarWidth = this._getScrollbarWidth();
    document.addEventListener('scroll', this._closeCallback);
    requestAnimationFrame( // update "late" in case this element lives before the target in the DOM on first render
    () => {
      this._updateTargetBindings(this.target);

      this._updateDomObservers();
    });
  }

  componentDidRender() {
    this._setPosition();
  }

  componentDisconnected() {
    document.removeEventListener('scroll', this._closeCallback);

    this._removeTargetBindings();

    this._removeResizeObservers();

    this._removeMutationObservers();
  }

  render() {
    return html`
      <div class="content" @click="${e => this._defaultTrigger && e.stopPropagation()}">
        <slot></slot>
      </div>
      ${this._defaultTrigger && !this.noBackdrop ? html`<div class="backdrop" @click="${() => this.open = false}"></div>` : nothing}
    `;
  }

  _setPosition() {
    this.style.top = '';
    this.style.right = '';
    this.style.bottom = '';
    this.style.left = '';

    if (this.open) {
      const offsets = this._calculateOffsets();

      this.style.top = offsets.top !== undefined ? offsets.top + 'px' : '';
      this.style.right = offsets.right !== undefined ? offsets.right + 'px' : '';
      this.style.bottom = offsets.bottom !== undefined ? offsets.bottom + 'px' : '';
      this.style.left = offsets.left !== undefined ? offsets.left + 'px' : '';
    }
  }
  /**
   * TODO: take scrollbars into account: currently active scrollbars break vertical positioning
   */


  _calculateOffsets() {
    var _this$_resolveTarget;

    const targetRect = (_this$_resolveTarget = this._resolveTarget(this.target)) === null || _this$_resolveTarget === void 0 ? void 0 : _this$_resolveTarget.getBoundingClientRect();
    const tipStyle = getComputedStyle(this, ':before');
    const tipWidth = parseInt(tipStyle.width, 10);
    const tipMiddleOffsetX = parseInt(tipStyle.left, 10) + tipWidth / 2;
    const tipMiddleOffsetY = parseInt(tipStyle.top, 10) + tipWidth / 2;

    if (!targetRect) {
      return {
        bottom: undefined,
        left: undefined,
        top: tipWidth,
        right: tipWidth
      };
    }

    let top;
    let right;
    let bottom;
    let left;
    const tipDistanceFacor = 1.2;

    switch (this.side) {
      case 'left':
        right = window.innerWidth - window.scrollX + this._getScrollbarOffsetX() - targetRect.left + tipWidth * tipDistanceFacor;
        top = targetRect.top + window.scrollY - tipMiddleOffsetY + targetRect.height / 2;
        break;

      case 'top':
        left = targetRect.left + targetRect.width / 2 - tipMiddleOffsetX;
        bottom = window.innerHeight - window.scrollY + this._getScrollbarOffsetY() - targetRect.top + tipWidth * tipDistanceFacor;
        break;

      case 'right':
        left = targetRect.left + window.scrollX + targetRect.width + tipWidth * tipDistanceFacor;
        top = targetRect.top + window.scrollY - tipMiddleOffsetY + targetRect.height / 2;
        break;

      default:
        // bottom & others
        left = targetRect.left + targetRect.width / 2 - tipMiddleOffsetX;
        top = targetRect.top + targetRect.height + window.scrollY + tipWidth * tipDistanceFacor;
    }

    return {
      top,
      right,
      bottom,
      left
    };
  }

  _getScrollbarOffsetX() {
    return this._isHorizontalScrollbarVisible() ? this._scrollbarWidth : 0;
  }

  _getScrollbarOffsetY() {
    return this._isVerticalScrollbarVisible() ? this._scrollbarWidth : 0;
  }

  _isHorizontalScrollbarVisible() {
    const element = document.querySelector(':root');
    return element.scrollHeight > element.clientHeight;
  }

  _isVerticalScrollbarVisible() {
    const element = document.querySelector(':root');
    return element.scrollWidth > element.clientWidth;
  }

  _getScrollbarWidth() {
    const container = document.createElement('div');
    const child = document.createElement('div');
    container.style.cssText = `
      visibility: hidden;
      overflow: scroll;
    `;
    container.appendChild(child);
    document.body.appendChild(container);
    const result = child.offsetWidth - container.offsetWidth;
    document.body.removeChild(container);
    return result;
  }

  _updateDomObservers() {
    this._removeResizeObservers();

    this._removeMutationObservers();

    this._observeTargetAndAncestors();
  }

  _removeResizeObservers() {
    this._resizeObservers.forEach(observer => {
      observer.disconnect();
    });
  }

  _removeMutationObservers() {
    this._mutationObservers.forEach(observer => {
      observer.disconnect();
    });
  }

  _observeTargetAndAncestors() {
    let element = this._resolveTarget(this.target);

    while (element && element !== document.body) {
      this._observe(element);

      element = element.parentElement;
    }

    this._observe(document.body);
  }

  _observe(element) {
    const resizeObserver = new ResizeObserver(this._setPositionCallback);
    resizeObserver.observe(element);

    this._resizeObservers.push(resizeObserver);

    const mutationObserver = new MutationObserver(this._setPositionCallback);
    mutationObserver.observe(element, {
      attributes: true
    });

    this._mutationObservers.push(mutationObserver);
  }

  _resolveTarget(target) {
    if (target instanceof Element) {
      return target;
    } else if (target) {
      return document.querySelector(target);
    }

    return undefined;
  }

  _updateTargetBindings(newTarget, oldTarget) {
    this._removeTargetBindings(this._resolveTarget(oldTarget || newTarget));

    const targetEl = this._resolveTarget(newTarget);

    if (!targetEl || this.trigger === 'none') {
      return;
    } else if (this.trigger === 'hover') {
      targetEl.addEventListener('mouseenter', this._openCallback);
      targetEl.addEventListener('mouseleave', this._closeCallback);
    } else {
      targetEl.addEventListener('click', this._toggleCallback);
    }
  }

  _removeTargetBindings(target) {
    const targetEl = this._resolveTarget(target);

    targetEl === null || targetEl === void 0 ? void 0 : targetEl.removeEventListener('click', this._toggleCallback);
    targetEl === null || targetEl === void 0 ? void 0 : targetEl.removeEventListener('mouseenter', this._openCallback);
    targetEl === null || targetEl === void 0 ? void 0 : targetEl.removeEventListener('mouseleave', this._closeCallback);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "altDirection", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "noBackdrop", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "open", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "side", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'bottom';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "target", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "trigger", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "openEvent", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "_defaultTrigger", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.trigger !== 'none' && this.trigger !== 'hover';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "onTargetChange", [_dec20, _dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "onTargetChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onOpenChange", [_dec22, _dec23], Object.getOwnPropertyDescriptor(_class2.prototype, "onOpenChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onTriggerChange", [_dec24, _dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "onTriggerChange"), _class2.prototype)), _class2)) || _class);
